function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(30.980392%,30.588235%,81.568627%)",
      fillOpacity: 1
    },
    d: "M 39.664062 21.386719 L 14.234375 21.386719 L 26.816406 5.601562 C 27.617188 4.601562 27.453125 3.144531 26.453125 2.347656 C 25.453125 1.550781 23.992188 1.714844 23.195312 2.714844 L 6.019531 24.253906 L 23.214844 45.304688 C 23.671875 45.859375 24.339844 46.152344 25.011719 46.152344 C 25.523438 46.152344 26.046875 45.980469 26.476562 45.632812 C 27.460938 44.820312 27.609375 43.359375 26.804688 42.367188 L 13.441406 26.019531 L 39.664062 26.019531 C 40.941406 26.019531 41.980469 24.980469 41.980469 23.703125 C 41.980469 22.421875 40.941406 21.386719 39.664062 21.386719 Z M 39.664062 21.386719 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.fe486e8972be77dd4dbab4d7bf8a9fbb.svg";
export { ForwardRef as ReactComponent };